import { render } from "./Home-App.vue?vue&type=template&id=4327334a&scoped=true"
import script from "./Home-App.vue?vue&type=script&lang=js"
export * from "./Home-App.vue?vue&type=script&lang=js"

import "./Home-App.vue?vue&type=style&index=0&id=4327334a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4327334a"]])

export default __exports__